import { Button } from "@/components/ui/button";
import { FileSpreadsheet, FileText } from 'lucide-react';
import { reportExportService } from '../../../services/reportExport.service';
import type { Flight, Accommodation, DeductibleExpense, PerDiem } from '../../../context/RefundReportContext';

interface ExportButtonsProps {
  tripName: string;
  tripDates?: string;
  tripReason?: string;
  flights: Flight[];
  accommodations: Accommodation[];
  deductibleExpenses: DeductibleExpense[];
  perDiems: PerDiem[];
  currency: string;
  flightTotal: number;
  accommodationTotal: number;
  deductibleTotal: number;
  perDiemTotal: number;
  grandTotal: number;
  totalCost: number;
  businessName?: string;
  businessLogo?: string;
}

export const ExportButtons: React.FC<ExportButtonsProps> = ({
  tripName,
  tripDates,
  tripReason,
  flights,
  accommodations,
  deductibleExpenses,
  perDiems,
  currency,
  flightTotal,
  accommodationTotal,
  deductibleTotal,
  perDiemTotal,
  grandTotal,
  totalCost,
  businessName,
  businessLogo,
}) => {
  const handleExportExcel = () => {
    reportExportService.exportToExcel(
      {
        tripName,
        tripDates,
        tripReason,
        flights,
        accommodations,
        deductibleExpenses,
        perDiems,
        currency,
        businessName,
        businessLogo,
      },
      {
        flightTotal,
        accommodationTotal,
        deductibleTotal,
        perDiemTotal,
        grandTotal,
        totalCost,
      }
    );
  };

  const handleExportPDF = async () => {
    await reportExportService.exportToPDF(
      {
        tripName,
        tripDates,
        tripReason,
        flights,
        accommodations,
        deductibleExpenses,
        perDiems,
        currency,
        businessName,
        businessLogo,
      },
      {
        flightTotal,
        accommodationTotal,
        deductibleTotal,
        perDiemTotal,
        grandTotal,
        totalCost,
      }
    );
  };

  return (
    <div className="flex gap-2">
      <Button
        onClick={handleExportExcel}
        variant="outline"
        className="flex items-center gap-2"
      >
        <FileSpreadsheet className="h-4 w-4" />
        Export to Excel
      </Button>
      <Button
        onClick={handleExportPDF}
        variant="outline"
        className="flex items-center gap-2"
      >
        <FileText className="h-4 w-4" />
        Export to PDF
      </Button>
    </div>
  );
};
